const config = document.getElementById('reel-player-config');
const HAND_URL  = config.dataset.handUrl;
const THUMB_URL = config.dataset.thumbUrl;

const handOverlay = document.getElementById('hand-overlay');
const reelPlayer  = document.getElementById('reel-player');
const reelVideo   = document.getElementById('reel-video');

// ── Calibration — measured from hand.png at 1423×739 viewport ──
const CAL = {
  viewport: { width: 1423, height: 739 },
  box:      { top: 67, left: 535, width: 254, height: 530, borderRadius: 36 }
};

// ── Helpers: compute cover/contain-fit dimensions ───────────────
function fitCover(cW, cH, iW, iH) {
  const cR = cW / cH, iR = iW / iH;
  let rW, rH, oX, oY;
  if (cR > iR) { rW = cW; rH = cW / iR; oX = 0;          oY = (cH - rH) / 2; }
  else         { rH = cH; rW = cH * iR;  oX = (cW - rW) / 2; oY = 0;          }
  return [rW, rH, oX, oY];
}

function fitContain(cW, cH, iW, iH) {
  const cR = cW / cH, iR = iW / iH;
  let rW, rH, oX, oY;
  if (cR > iR) { rH = cH; rW = cH * iR;  oX = (cW - rW) / 2; oY = 0;          }
  else         { rW = cW; rH = cW / iR;   oX = 0;              oY = (cH - rH) / 2; }
  return [rW, rH, oX, oY];
}

// ── Hand / thumb switching ──────────────────────────────────────
const HandOverlay = {
  hand:  HAND_URL,
  thumb: THUMB_URL,
  timer: null,

  showThumb() {
    clearTimeout(this.timer);
    handOverlay.src = this.thumb;
    handOverlay.style.zIndex = '14';
  },

  showHandDelayed() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      handOverlay.src = this.hand;
      handOverlay.style.zIndex = '14';
    }, 300);
  }
};

// ── Reel player ─────────────────────────────────────────────────
let unlocked = false; // set to true on first overlay click

const ReelsPlayer = {
  reels: [...document.querySelectorAll('.reel-src')].map(el => el.dataset.src),
  currentIndex: 0,

  init() {
    if (this.reels.length > 0) this.load(0);
  },

  load(index) {
    if (index < 0)                  index = this.reels.length - 1;
    if (index >= this.reels.length) index = 0;
    this.currentIndex = index;
    reelVideo.src = this.reels[index];
    reelVideo.load();
    if (unlocked) reelVideo.play().catch(() => {});
  },

  next() { this.transition('up',   () => this.load(this.currentIndex + 1)); },
  prev() { this.transition('down', () => this.load(this.currentIndex - 1)); },

  transition(direction, callback) {
    const exitY  = direction === 'up' ? '-100%' : '100%';
    const enterY = direction === 'up' ? '100%'  : '-100%';

    reelVideo.style.transition = 'transform 0.3s ease-out';
    reelVideo.style.transform  = `translateY(${exitY})`;

    setTimeout(() => {
      reelVideo.style.transition = 'none';
      reelVideo.style.transform  = `translateY(${enterY})`;
      callback();
      requestAnimationFrame(() => {
        reelVideo.style.transition = 'transform 0.3s ease-out';
        reelVideo.style.transform  = 'translateY(0)';
      });
    }, 300);
  },

  updatePosition() {
    if (!handOverlay.naturalWidth) return;

    const fitFn = window.innerWidth >= 768 ? fitContain : fitCover;
    const [rW, rH, oX, oY]    = fitFn(window.innerWidth, window.innerHeight, handOverlay.naturalWidth, handOverlay.naturalHeight);
    const [crW, crH, coX, coY] = fitCover(CAL.viewport.width, CAL.viewport.height, handOverlay.naturalWidth, handOverlay.naturalHeight);

    const { top, left, width, height, borderRadius } = CAL.box;

    reelPlayer.style.cssText = `
      position: fixed;
      top:           ${ ((top    - coY) / crH) * rH + oY }px;
      left:          ${ ((left   - coX) / crW) * rW + oX - 1 + 42 }px;
      width:         ${ (width  / crW) * rW }px;
      height:        ${ (height / crH) * rH }px;
      border-radius: ${ (borderRadius / crH) * rH }px;
      overflow: hidden;
      z-index: 12;
      background: #000;
      cursor: grab;
      pointer-events: auto;
    `;
  }
};

// ── Input ───────────────────────────────────────────────────────
const Input = {
  startY: 0, endY: 0, dragging: false, threshold: 50, wheelLocked: false, wheelTimer: null,

  init() {
    // Touch
    reelPlayer.addEventListener('touchstart', e => {
      this.startY = e.touches[0].clientY;
      HandOverlay.showThumb();
    }, { passive: true });

    reelPlayer.addEventListener('touchmove', e => {
      this.endY = e.touches[0].clientY;
    }, { passive: true });

    reelPlayer.addEventListener('touchend', () => {
      this.handleSwipe();
      HandOverlay.showHandDelayed();
    });

    // Mouse drag
    reelPlayer.addEventListener('mousedown', e => {
      this.dragging = true;
      this.startY = e.clientY;
      reelPlayer.style.cursor = 'grabbing';
      HandOverlay.showThumb();
    });

    document.addEventListener('mousemove', e => {
      if (this.dragging) this.endY = e.clientY;
    });

    document.addEventListener('mouseup', () => {
      if (!this.dragging) return;
      this.handleSwipe();
      this.dragging = false;
      reelPlayer.style.cursor = 'grab';
      HandOverlay.showHandDelayed();
    });

    // Scroll wheel — navigate once on the leading edge, unlock only after
    // wheel events stop arriving (handles trackpad momentum)
    reelPlayer.addEventListener('wheel', e => {
      e.preventDefault();
      clearTimeout(this.wheelTimer);
      this.wheelTimer = setTimeout(() => { this.wheelLocked = false; }, 200);
      if (this.wheelLocked) return;
      this.wheelLocked = true;
      HandOverlay.showThumb();
      e.deltaY > 0 ? ReelsPlayer.next() : ReelsPlayer.prev();
      HandOverlay.showHandDelayed();
    }, { passive: false });
  },

  handleSwipe() {
    const diff = this.startY - this.endY;
    if (Math.abs(diff) > this.threshold) {
      diff > 0 ? ReelsPlayer.next() : ReelsPlayer.prev();
    }
    this.startY = this.endY = 0;
  }
};

// ── Boot ────────────────────────────────────────────────────────
new Image().src = HandOverlay.thumb; // preload thumb

if (handOverlay.complete) {
  ReelsPlayer.updatePosition();
} else {
  handOverlay.addEventListener('load', () => ReelsPlayer.updatePosition());
}

window.addEventListener('resize', () => ReelsPlayer.updatePosition());

Input.init();
ReelsPlayer.init();

// Play overlay — dismiss on click and unlock playback
const playOverlay = document.getElementById('reel-play-overlay');
if (playOverlay) {
  // Block overlay interactions from bubbling into the swipe/drag handlers
  ['mousedown', 'touchstart', 'touchend'].forEach(type => {
    playOverlay.addEventListener(type, e => e.stopPropagation());
  });

  playOverlay.addEventListener('click', () => {
    unlocked = true;
    playOverlay.classList.add('is-hidden');
    reelVideo.play().catch(() => {});
  });
}
